import React, { useEffect, useRef } from 'react';

const Benefits = () => {
  const benefitRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      });
    }, observerOptions);

    benefitRefs.current.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => {
      benefitRefs.current.forEach(el => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  const benefits = [
    {
      icon: '⏱️',
      title: 'Time Savings',
      description: 'Complete VAT calculations in seconds instead of minutes. Process multiple invoices daily with efficiency, allowing staff to focus on strategic tasks rather than repetitive number crunching.'
    },
    {
      icon: '✅',
      title: '100% Accuracy',
      description: 'Eliminate mathematical mistakes and human errors. Ensure tax amounts are computed correctly every time, maintaining compliance with tax regulations and avoiding costly penalties.'
    },
    {
      icon: '💰',
      title: 'Cost-Effective',
      description: 'Access professional-grade calculation capabilities without expensive accounting software or additional staff. An affordable solution that provides enterprise-level functionality for businesses of all sizes.'
    },
    {
      icon: '📊',
      title: 'Enhanced Transparency',
      description: 'Provide clear breakdowns of net amounts, tax amounts, and gross totals. Build trust with clients through transparent billing practices and support better financial planning.'
    },
    {
      icon: '🚀',
      title: 'Improved Efficiency',
      description: 'Streamline financial workflows and reduce processing time. Handle multiple calculations simultaneously while maintaining accuracy and precision in every transaction.'
    },
    {
      icon: '📈',
      title: 'Better Decision Making',
      description: 'Quickly generate accurate tax information to support financial planning and budgeting. Make more informed decisions about pricing, margins, and profitability with real-time calculations.'
    }
  ];

  return (
    <section className="benefits-section">
      <div className="benefits-container">
        <h2 className="section-title">Benefits of Using VAT Calculator</h2>
        <p className="section-subtitle">Discover the advantages that make VAT calculations effortless and efficient</p>

        <div className="features-grid">
          {benefits.map((benefit, index) => (
            <div
              key={benefit.title}
              className="feature-card"
              ref={el => benefitRefs.current[index] = el}
            >
              <div className="feature-icon">{benefit.icon}</div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
